/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gallery_EmptyInputs */

const en_us2_gallery_empty = /** @type {(inputs: Gallery_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No plan published yet.`)
};

const pt_br2_gallery_empty = /** @type {(inputs: Gallery_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum plano publicado ainda.`)
};

const pt_pt2_gallery_empty = /** @type {(inputs: Gallery_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum plano publicado ainda.`)
};

/** @type {(inputs: Gallery_EmptyInputs) => LocalizedString} */
const es_419_gallery_empty = en_us2_gallery_empty;

/** @type {(inputs: Gallery_EmptyInputs) => LocalizedString} */
const fr_fr2_gallery_empty = en_us2_gallery_empty;

/** @type {(inputs: Gallery_EmptyInputs) => LocalizedString} */
const de_de2_gallery_empty = en_us2_gallery_empty;

/** @type {(inputs: Gallery_EmptyInputs) => LocalizedString} */
const it_it2_gallery_empty = en_us2_gallery_empty;

/**
* | output |
* | --- |
* | "No plan published yet." |
*
* @param {Gallery_EmptyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const gallery_empty = /** @type {((inputs?: Gallery_EmptyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gallery_EmptyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_gallery_empty(inputs)
	if (locale === "es-419") return es_419_gallery_empty(inputs)
	if (locale === "pt-PT") return pt_pt2_gallery_empty(inputs)
	if (locale === "fr-FR") return fr_fr2_gallery_empty(inputs)
	if (locale === "de-DE") return de_de2_gallery_empty(inputs)
	if (locale === "it-IT") return it_it2_gallery_empty(inputs)
	return en_us2_gallery_empty(inputs)
});
export { gallery_empty as "gallery.empty" }